import BaseApi from './BaseApi';

class NewsApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/news';
  }
}

export default NewsApi;
